import { SettingOutlined } from '@ant-design/icons-vue'
export default [
  {
    path: '/organization',
    name: 'organization',
    redirect: '/organization/user',
    meta: {
      title: '组织管理',
      sort: 5,
      icon: SettingOutlined,
      isFullScreen: false,
      keepAlive: true,
      hidden: false,
      prem: true,
    },
    children: [
      {
        path: '/organization/user',
        name: 'organizationUser',
        component: () => import('@/views/system/user/index.vue'),
        meta: {
          title: '用户管理',
          sort: 3,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/organization/role',
        name: 'organizationRole',
        component: () => import('@/views/system/role/index.vue'),
        meta: {
          title: '角色管理',
          sort: 4,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/organization/menu',
        name: 'organizationMenu',
        component: () => import('@/views/system/menu/index.vue'),
        meta: {
          title: '菜单管理',
          sort: 5,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/system/dicManager',
        name: 'systemDicManager',
        component: () => import('@/views/system/dicManager/index.vue'),
        meta: {
          title: '字典类管理',
          sort: 6,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },

      {
        path: '/system/dicItemManager',
        name: 'systemDicItemManager',
        component: () => import('@/views/system/dicItemManager/index.vue'),
        meta: {
          title: '字典项管理',
          sort: 6,
          isFullScreen: false,
          keepAlive: false,
          hidden: true,
          prem: true,
        },
      },

      {
        path: '/organization/guardian',
        name: 'organizationGuardian',
        component: () => import('@/views/system/guardian/index.vue'),
        meta: {
          title: '用户档案',
          sort: 6,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/organization/guardian-map',
        name: 'organizationGuardianMap',
        component: () => import('@/views/system/guardian/map/index.vue'),
        meta: {
          title: '维护住址',
          isFullScreen: false,
          keepAlive: false,
          hidden: true,
          prem: true,
        },
      },
    ],
  },
]
